import Vue from "vue";
import Component from "vue-class-component";
import XTh from "./x-th";

@Component
export default class ActionTH extends Vue {

  render() {
    return <XTh sortable={false} class="action-th">#</XTh>;
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3a8698b2/action-th.tsx" });